import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AngularFireAuth } from '@angular/fire/compat/auth';

@Component({
  selector: 'app-new-product',
  templateUrl: './new-product.component.html',
  styleUrls: ['./new-product.component.scss']
})
export class NewProductComponent implements OnInit {

  @Input() verified: boolean = false;

  productForm: FormGroup;
  coverImage: File | null = null;
  additionalImages: File[] = [];
  uploadPercent: number | null = null;
  categories: any[] = []; // Store fetched categories from Firestore
  extraImagesUrls: string[] = [];

  constructor(
    private fb: FormBuilder,
    private afs: AngularFirestore,
    private afAuth: AngularFireAuth,
    private storage: AngularFireStorage
  ) {
    this.productForm = this.fb.group({
      name: ['', Validators.required],
      brand: [''],
      description: ['', Validators.required],
      unitPrice: [0, [Validators.required, Validators.min(0)]],
      quantity: [0, [Validators.required, Validators.min(0)]],
      category: ['', Validators.required],
      cover: [null],
      rating: [0],
      images: [null],
      verified: [false],
      shown: [true],
      createdAt: [null],
      updatedAt: [null],
      specifications: [''] /*this.fb.array([
        this.fb.group({
          size: [''],
          type: [''],
          voltage: [''],
          capacity: [''],
          others: [''],
        }),
      ]),*/,
      ownerId: ['']
    });
  }

  ngOnInit() {
    this.getCategories();
    console.log('Verified:', this.verified);

    this.afAuth.authState.subscribe((user) => {
      if (user) {
        this.productForm.controls['ownerId'].setValue(user.uid);
      }
    })

    this.productForm.controls['verified'].setValue(this.verified);
  }

  getCategories() {
    this.afs.collection('productCategories').valueChanges()
      .subscribe((categories: any) => {
        this.categories = categories;
      });
  }

  onCoverSelected(event: any) {
    this.coverImage = event.files[0];
  }

  onAdditionalImagesSelected(event: any) {
    const filesArray = Array.from(event.files as FileList);
    this.additionalImages.push(...filesArray);
    console.log('Selected images:', this.additionalImages);
  }

  async addProduct() {
    if (this.productForm.invalid || !this.coverImage) {
      return;
    }

    

    const { name, brand, description, unitPrice, quantity, category, rating, verified, shown, specifications, ownerId } = this.productForm.value;

    try {
      // Upload cover image
      const coverPath = `products/${Date.now()}_${this.coverImage?.name}`;
      const coverFileRef = this.storage.ref(coverPath);
      const coverTask = this.storage.upload(coverPath, this.coverImage);

      coverTask.percentageChanges().subscribe((percent) => {
        this.uploadPercent = percent!;
      });

      await coverTask.snapshotChanges().toPromise(); // Wait for cover image upload
      const coverUrl = await coverFileRef.getDownloadURL().toPromise();

      // Upload additional images
      const imageUploadPromises = this.additionalImages.map(async (image) => {
        const imagePath = `products/${Date.now()}_${image.name}`;
        const imageFileRef = this.storage.ref(imagePath);
        const imageTask = this.storage.upload(imagePath, image);

        await imageTask.snapshotChanges().toPromise(); // Wait for each image upload
        const imageUrl = await imageFileRef.getDownloadURL().toPromise();
        this.extraImagesUrls.push(imageUrl); // Add the URL to the array
      });

      // Wait for all images to be uploaded and URLs fetched
      await Promise.all(imageUploadPromises);

      // Now save the product data
      const productData = {
        name,
        brand,
        description,
        unitPrice,
        quantity,
        category,
        feedbacks: [],
        cover: coverUrl,
        images: this.extraImagesUrls,
        rating: 0,
        verified,
        shown,
        createdAt: new Date(),
        updatedAt: new Date(),
        specifications,
        ownerId
      };

      console.log('Product data to be saved:', productData); // Log to verify data

      await this.afs.collection('products').add(productData);
      console.log('Product added successfully');
      this.productForm.reset();
      this.uploadPercent = null;

    } catch (error) {
      console.error('Error adding product: ', error);
    }
  }
}